/**
 * Data layer for `datacenter-traffic-block-aws-gcp-azure-ip-blacklist`. Thin typed fetch wrappers over /api/v1/datacenter-traffic-block-aws-gcp-azure-ip-blacklist.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListDatacenterTrafficBlockAwsGcpAzureIpBlacklistResponse {
	count: number;
	items: DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow[];
}

export interface CreateDatacenterTrafficBlockAwsGcpAzureIpBlacklistBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/datacenter-traffic-block-aws-gcp-azure-ip-blacklist";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListDatacenterTrafficBlockAwsGcpAzureIpBlacklistResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListDatacenterTrafficBlockAwsGcpAzureIpBlacklistResponse>(res);
}

export async function create(body: CreateDatacenterTrafficBlockAwsGcpAzureIpBlacklistBody): Promise<DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys = {
	all: ["datacenter-traffic-block-aws-gcp-azure-ip-blacklist"] as const,
	list: () => [...datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys.all] as const,
	detail: (id: string) => [...datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys.all, id] as const,
};
